var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgAlertIssue = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 25,
  height: 25,
  viewBox: "0 0 25 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.31674 3.39299C8.50428 3.20545 8.75863 3.1001 9.02385 3.1001H15.9789C16.2441 3.1001 16.4985 3.20545 16.686 3.39299L21.6083 8.31528C21.7958 8.50281 21.9012 8.75717 21.9012 9.02238V15.9774C21.9012 16.2426 21.7958 16.497 21.6083 16.6845L16.686 21.6068C16.4985 21.7944 16.2441 21.8997 15.9789 21.8997H9.02385C8.75863 21.8997 8.50428 21.7944 8.31674 21.6068L3.39446 16.6845C3.20692 16.497 3.10156 16.2426 3.10156 15.9774V9.02238C3.10156 8.75717 3.20692 8.50281 3.39446 8.31528L8.31674 3.39299ZM9.43806 5.1001L5.10156 9.4366V15.5632L9.43806 19.8997H15.5647L19.9012 15.5632V9.4366L15.5647 5.1001H9.43806Z",
  fill: "#15A779"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.5 15.8599C11.5 15.3076 11.9477 14.8599 12.5 14.8599H12.5084C13.0607 14.8599 13.5084 15.3076 13.5084 15.8599C13.5084 16.4121 13.0607 16.8599 12.5084 16.8599H12.5C11.9477 16.8599 11.5 16.4121 11.5 15.8599Z",
  fill: "#15A779"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12.5 8.14014C13.0523 8.14014 13.5 8.58785 13.5 9.14014V12.5001C13.5 13.0523 13.0523 13.5001 12.5 13.5001C11.9477 13.5001 11.5 13.0523 11.5 12.5001V9.14014C11.5 8.58785 11.9477 8.14014 12.5 8.14014Z",
  fill: "#15A779"
})));
export default SvgAlertIssue;